import React from 'react';
import Select from 'react-select';

const InvoiceStatusSection = ({ 
    data,
    updatedClient, 
    invoiceStatuses, 
    setInvoiceStatuses 
}) => {
    // Convert invoiceStatuses to react-select format
    const options = invoiceStatuses.map(status => ({
        value: status,
        label: data.t.read("status." + status.toLowerCase()) ?? status,
        isDisabled: ["Need_Approval", "Approved", "Denied"].includes(status) && 
                   (updatedClient.config.components.findIndex(comp => "approval" === comp.name) === -1)
    }));

    // Get currently selected values
    const selectedValues = (updatedClient.config.invoice_status || []).map(status => ({
        value: status,
        label: data.t.read("status." + status.toLowerCase()) ?? status
    }));


    return (
        <div className='mb-2'>
            <h5 className='mt-4'>Invoice Status</h5>
            <div className="row mt-1">
                <div className='col-2'>Invoice Status :</div>
                <div className='col-10'>
                    <Select
                        isMulti
                        options={options}
                        value={selectedValues}
                        onChange={(selectedOptions) => {
                            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                            setInvoiceStatuses(selectedValues);
                        }}
                        placeholder="Select invoice statuses..."
                        className="react-select-container"
                        classNamePrefix="react-select"
                    />
                </div>
            </div>
        </div>
    );
};

export default InvoiceStatusSection;
